import { put, takeLatest } from 'redux-saga/effects';
import actionTypes from '../../types/reconciliationTypes';
import { GLOBAL_URL } from '../../../shared/constants/dataServiceUrl';
import SendRequest from '../../../shared/services/sendRequest.service';
import { setInsurerWiseTds, setIsTableLoading, setReconciliationData, setReconciliationDetail } from '../../actions/reconciliationAction';
import { centeredNotification } from '../../../utils/utility';

export function* downloadFile({ payload }: any): Generator {
  const sendRequest = SendRequest.instance;
  try {
    const path = GLOBAL_URL.CRM_BASE_URL + payload.url;
    const response: any = yield sendRequest.post<any, any>(path, payload.payload);
    const { isSuccess, fileName, fileBytes, errorMessage } = response || {};
    if (isSuccess) {
      let mimeType = '';
      if (payload.extension === 'pdf') {
        mimeType = 'application/pdf';
      } else if (['png', 'jpg', 'jpeg'].indexOf(payload.extension) >= 0) {
        mimeType = 'image/' + payload.extension;
      } else if (['xlsx', 'xls'].indexOf(payload.extension) >= 0) {
        mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      } else if (payload.extension === 'csv') {
        mimeType = 'text/csv ';
      }
      const linkSource = 'data:' + mimeType + ';base64,' + fileBytes;
      const downloadLink = document.createElement('a');
      downloadLink.href = linkSource;
      downloadLink.download = fileName ? fileName?.split('.') + '.' + payload.extension : 'downloaded_file';
      document.body.appendChild(downloadLink);
      downloadLink.click();
      downloadLink.remove();
      payload.onSuccess();
    } else {
      centeredNotification(errorMessage);
      payload.onError();
    }
  } catch { }
}

export function* getReconciliationData({ payload }: any): Generator {
  const sendRequest = SendRequest.instance;
  try {
    yield put(setReconciliationData({reconciliationDetails: [], totalClaimedAmount: 0, totalApprovedAmount: 0,
      paidAmount: 0, tdsAmount: 0, pendingAmount: 0, totalSettledClaims: 0, reconciledClaims: 0, shortPaidClaims: 0,
      notPaidClaims: 0, totalUTRMappedClaims: 0, lastStatusUpdated: ''}));
    yield put(setIsTableLoading(true));
    const url = `${GLOBAL_URL.CRM_BASE_URL}Reconciliation/GetReconcileData`;
    const response: any = yield sendRequest.post<any, any>(url, payload);
    const { isSuccess, reconciliationDetails, totalClaimedAmount, totalApprovedAmount,
      paidAmount, tdsAmount, pendingAmount, totalSettledClaims, totalUTRMappedClaims, reconciledClaims,
      shortPaidClaims, notPaidClaims, lastStatusUpdated } = response || {};
    if (isSuccess) {
      yield put(setReconciliationData({
        reconciliationDetails, totalClaimedAmount, totalApprovedAmount,
        paidAmount, tdsAmount, pendingAmount, totalSettledClaims, totalUTRMappedClaims, reconciledClaims,
        shortPaidClaims, notPaidClaims, lastStatusUpdated, isTableLoading: false,
      }));
      yield put(setIsTableLoading(false));
    } else {
      yield put(setIsTableLoading(false));
    }
  } catch { }
}

export function* getInsurerWiseTdsRates(): Generator {
  const sendRequest = SendRequest.instance;

  try {
    yield put(setIsTableLoading(true));
    const url = `${GLOBAL_URL.CRM_BASE_URL}Reconciliation/GetTDSConfiguration`;

    const response: any = yield sendRequest.post<any, any>(url, {});

    const { isSuccess, reconciliationTDSConfiguration } = response;
    if (isSuccess) {
      yield put(setIsTableLoading(false));
      yield (put(setInsurerWiseTds(reconciliationTDSConfiguration)));
    }
  } catch {

  }
}

export function* updateInsurerWiseRdsRates({ payload }: any): Generator {
  const sendRequest = SendRequest.instance;
  try {
    yield put(setIsTableLoading(true));
    const url = `${GLOBAL_URL.CRM_BASE_URL}Reconciliation/AddorUpdateTDSConfiguration`;
    const response: any = yield sendRequest.post<any, any>(url, payload);
    const { isSuccess, errorMessage } = response;
    if (isSuccess) {
      yield put(setIsTableLoading(false));
    } else {
      centeredNotification(errorMessage);
    }
  } catch { }

}

export function* getReconciliationDetails({payload}: any): Generator {
  const sendRequest = SendRequest.instance;
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}Reconciliation/GetReconciliationDetails`;
    const response: any = yield sendRequest.post<any, any>(url, payload);
    const { isSuccess, reconciliationAuditTrail,
      reconciliationLinkedClaims, manualReconciliationData } = response;
    if (isSuccess) {
      yield (put(setReconciliationDetail({reconciliationAuditTrail, reconciliationLinkedClaims, manualReconciliationData})));
    }

  } catch {

  }
}

export function* updateReconciliationData({payload}: any): Generator {
  const sendRequest = SendRequest.instance;
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}Reconciliation/AddOrUpdateReconciliationAuditTrail`;
    const response: any = yield sendRequest.post<any, any> (url, payload);
    const {isSuccess, errorMessage} = response;
    if (isSuccess) {
      centeredNotification('Data saved successfully.', 'success');
    } else {
      centeredNotification(errorMessage);
    }
  } catch {}
}

export function* watchReconciliation(): any {
  yield takeLatest(actionTypes.DOWNLOAD_RECONCILIATION_FILE, downloadFile);
  yield takeLatest(actionTypes.GET_RECONCILIATION_DATA, getReconciliationData);
  yield takeLatest(actionTypes.GET_INSURER_WISE_TDS_RATES, getInsurerWiseTdsRates);
  yield takeLatest(actionTypes.UPDATE_INSURER_WISE_TDS_RATES, updateInsurerWiseRdsRates);
  yield takeLatest(actionTypes.GET_RECONCILIATION_DETAIL, getReconciliationDetails);
  yield takeLatest(actionTypes.UPDATE_RECONCILIATION_DATA, updateReconciliationData);

}

export default watchReconciliation;
